export enum LayoutType {
  Top = "top",
  Bottom = "bottom",
  Left = "left",
  Right = "right",
  Full = "full",
}

/** Layouts whose secondary strip is horizontal (above/below the main player). */
export const HORIZONTAL_STRIP_LAYOUTS: ReadonlyArray<LayoutType> = [LayoutType.Top, LayoutType.Bottom];
/** Layouts whose secondary strip is vertical (next to the main player). */
export const VERTICAL_STRIP_LAYOUTS: ReadonlyArray<LayoutType> = [LayoutType.Left, LayoutType.Right];

export const isHorizontalStripLayout = (layout: LayoutType): boolean =>
  HORIZONTAL_STRIP_LAYOUTS.includes(layout);
export const isVerticalStripLayout = (layout: LayoutType): boolean =>
  VERTICAL_STRIP_LAYOUTS.includes(layout);

/** Default set of layouts shown in the standard meeting selector. */
export const DEFAULT_LAYOUTS: ReadonlyArray<LayoutType> = [
  LayoutType.Bottom,
  LayoutType.Right,
  LayoutType.Full,
];

/** Keep in sync with CSS: @media (max-width: 1023px) */
export const MOBILE_BREAKPOINT = 1024;
